import { Environment } from '@troyai/envs';

const apiHost = window.location.hostname;
const apiUrl = `https://${apiHost}/api/v1`;

export const environment: Environment = {
  production: true,
  enableDebugTools: false,
  logLevel: 'error',
  apiHost,
  apiUrl,
  auth0ConnectionData: {
    domain: 'auth.troy.ai',
    clientId: 'jHgUtflqqpLPlcO7qLzbuZ799iHM5PA6',
    audience: 'https://portal.staging.troymedicare.com/api',
  },
};
